import { render, staticRenderFns } from "./TableDataImported.vue?vue&type=template&id=16be8894"
import script from "./TableDataImported.vue?vue&type=script&lang=js"
export * from "./TableDataImported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports